// useScrollReveal.js
import { useEffect } from "react";

export const useScrollReveal = (dependencies = []) => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("reveal-visible");
                        // IMPORTANTE: Dejar de observar una vez que ya es visible
                        // Esto evita que desaparezca al mover el layout
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.05 },
        ); // Threshold bajo para que detecte rápido

        const elements = document.querySelectorAll(".reveal");
        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, dependencies);
};
